import { getCampaignInfluencerTagLabel } from '@/marketing/models/campaignInfluencerTag';
import { useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';
import { CAMPAIGN_INFLUENCER_TAG_QUERIES } from '@/marketing/infrastructure/influencer/campaign/tag/utils/queries';

export interface CampaignInfluencerTagLookup {
  tagNameById: Map<string, string>;
  tagLabelById: Map<string, string>;
  globalTagIds: Set<string>;
  isReady: boolean;
  isError: boolean;
}

export function useCampaignInfluencerTagLookup(campaignId: string): CampaignInfluencerTagLookup {
  const { data: tags = [], isSuccess, isError } = useQuery(CAMPAIGN_INFLUENCER_TAG_QUERIES.list(campaignId));

  const tagNameById = useMemo(() => new Map(tags.map((tag) => [tag.tagId, tag.name])), [tags]);

  const tagLabelById = useMemo(
    () => new Map(tags.map((tag) => [tag.tagId, getCampaignInfluencerTagLabel(tag)])),
    [tags],
  );

  const globalTagIds = useMemo(() => new Set(tags.filter((tag) => !tag.campaignId).map((tag) => tag.tagId)), [tags]);

  return { tagNameById, tagLabelById, globalTagIds, isReady: isSuccess, isError };
}
